<script>
    let { id = null } = $props();
</script>
{#if id}
<svg class='svg-icon'><use xlink:href='/i/fa.svg#{id}'></use></svg>
{:else}
&nbsp;
{/if}
